import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useApp } from '../../context/AppContext';
import CustomerLayout from '../../components/CustomerLayout';
import PrisonSelection from './PrisonSelection';
import OrderForm from './OrderForm';
import Menu from './Menu';
import Cart from './Cart';
import OrderHistory from './OrderHistory';

function CustomerDashboard() {
  const { user } = useApp();
  const [selectedPrison, setSelectedPrison] = useState(null);
  const [visitingDetails, setVisitingDetails] = useState(null);

  if (!user || user.type !== 'customer') {
    return <div>Access denied</div>;
  }

  return (
    <CustomerLayout>
      <Routes>
        <Route 
          path="/" 
          element={
            <PrisonSelection 
              selectedPrison={selectedPrison}
              setSelectedPrison={setSelectedPrison}
            />
          } 
        />
        <Route 
          path="/order-form" 
          element={
            <OrderForm 
              selectedPrison={selectedPrison}
              visitingDetails={visitingDetails}
              setVisitingDetails={setVisitingDetails}
            />
          } 
        />
        <Route 
          path="/menu" 
          element={
            <Menu 
              selectedPrison={selectedPrison}
              visitingDetails={visitingDetails}
            />
          } 
        />
        <Route path="/cart" element={<Cart />} />
        <Route path="/orders" element={<OrderHistory />} />
      </Routes>
    </CustomerLayout>
  );
}

export default CustomerDashboard;